import React from 'react';
import { Layout } from 'antd';
import classnames from 'classnames';
import SearchBar from '../SearchBar';
import Header1Content from './Header1Content';
import SearchLocationSideBar from '../SearchLocationSideBar';
import { AppHeaderProps } from '../../common/types';

const AppHeader: React.FC<AppHeaderProps> = (Props: AppHeaderProps) => {
  const { Header } = Layout;
  const { visible } = Props;
  const [isSearchBarVisible, setSearchBar] = React.useState(false);
  const [isLocationSideBarVisible, setLocationSideBarVisible] = React.useState(
    false
  );

  const onClickSetSearchBar = (e: React.MouseEvent<HTMLElement>) => {
    setSearchBar(true);
  };

  const onClickCloseSearchBar = () => {
    setLocationSideBarVisible(false);
  };

  const onOpenLocation = (e: React.MouseEvent<HTMLElement>) => {
    setLocationSideBarVisible(true);
  };

  return (
    <Header
      style={{
        position: 'fixed',
        zIndex: 100,
        width: '100%',
        display: 'flex',
        willChange: 'transform',
        transform: 'translateZ(0)',
        transition: 'transform 0.7s ease',
        contain: 'size layout style'
      }}
      className={classnames({
        'header--hidden': !visible
      })}
    >
      <Header1Content
        {...Props}
        onOpenSearch={onClickSetSearchBar}
        onOpenLocation={onOpenLocation}
      />
      <SearchBar visible={isSearchBarVisible} onClose={onClickCloseSearchBar} />
      <SearchLocationSideBar
        visible={isLocationSideBarVisible}
        onClose={onClickCloseSearchBar}
      />
    </Header>
  );
};

export default AppHeader;
